export default "__VITE_ASSET__CrnAaM22__"